import { Injectable, EventEmitter, Inject } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe, DecimalPipe } from '@angular/common';
import { DurationFormatPipe } from '../pipes/duration-format.pipe';
import { IErrorHandler, IErrorHandlerToken } from '../dataModels';
import { ExportExcelModel } from '../dataModels/excel';
import { LocalizePipe } from '../pipes/Localize.pipe';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
    onExcelDataLoaded: EventEmitter<any> = new EventEmitter<any>();

    constructor(@Inject(IErrorHandlerToken) private _errorHandler: IErrorHandler, private _DurationFormatPipe: DurationFormatPipe, private decimalPipe: DecimalPipe
        , private _localizer: LocalizePipe) { }

    public exportAsExcelFile(json: any[], excelFileName: string): void {

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

        console.log('worksheet', worksheet);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    public exportAsExcelFileWithGrouping(body: any[], excelFileName: string, headers?: any[], footers?: any[]): void {



        const data = body;
        //var Excel = require('exceljs');
        //let workbook = new Workbook();
        //let worksheet = workbook.addWorksheet(excelFileName);

        let json: any[] = [];
        let header: any[] = [];
        if (data[0].length) {
            if (headers.length > 0) {

                var _headers = Object.keys(data[0][0]).map(x => {
                    return x;
                });
                _headers.forEach(h => {
                    let _h = headers.find(el => el.key == h);
                    if (_h) {
                        header.push(_h.header);
                    }
                });
                json.push(header)
            }


            // Object.keys(data[0][0]).map( x => {
            //     return x;
            // })
            data.forEach(key => {
                key.forEach(el => {
                    var row = Object.keys(el).map(x => {
                        return el[x]
                    })
                    json.push(row);
                })
                json.push([]);
            })
        } else {
            headers.forEach(_header => {
                header.push(_header.header);
            });
            json.push(header);
        }
        
        let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, { skipHeader: true, cellStyles: true });
        worksheet['A1'].s = {
            fill: {
                type: 'pattern',
                pattern: 'solid',
                bgColor: { argb: 'FF0000FF' }
            }
        };
        //worksheet.columns = columns;
        // XLSX.utils.format_cell()
        //worksheet.getRow(1).fill = {
        //    type: 'pattern',
        //    pattern: 'solid',
        //    fgColor: { argb: '84A5F0' }
        //}
        //let headerRow = worksheet.addRow(header);
        //headerRow.eachCell((cell, number) => {
        //    cell.fill = {
        //        type: 'pattern',
        //        pattern: 'solid',
        //        fgColor: { argb: 'FFFFFF00' },
        //        bgColor: { argb: 'FF0000FF' }
        //    }
        //    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        //})

        //data.forEach(key => {
        //    key.forEach(d => {
        //        let row = worksheet.addRow(d);              
        //        let color = '496095';
        //    }); 
        //    let sepertedRow = worksheet.addRow([]);
        //    sepertedRow.getCell(1).fill = {
        //        type: 'pattern',
        //        pattern: 'solid',
        //        fgColor: { argb: '496095' }
        //    };
        //    //sepertedRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        //    //Merge Cells
        //    worksheet.mergeCells(`A${sepertedRow.number}:P${sepertedRow.number}`);

        //}
        //);


        //Footer Row
        //let footerRow = worksheet.addRow(['This is system generated excel sheet.']);
        //footerRow.getCell(1).fill = {
        //    type: 'pattern',
        //    pattern: 'solid',
        //    fgColor: { argb: 'FFCCFFE5' }
        //};
        //footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        ////Merge Cells
        //worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

        //  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        //workbook.xlsx.writeBuffer().then((bufferedData) => {

        //    this.saveAsExcelFile(bufferedData, excelFileName);
        //})

        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        XLSX.writeFile(workbook, excelFileName + '_export_' + this.getReadableTime() + EXCEL_EXTENSION, { bookType: 'xlsx' });

    }
    getReadableTime() {
        let datePide = new DatePipe('en-US');
       return datePide.transform(new Date(), 'yyyy-MM-dd_HH:mm:ss');
       // let date = new Date();
       // return date.getFullYear() + '-' + date.getMonth() + '-' + date.getDay() + '-' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    }
    public importDataToJson(file: File, sheetNames: string[]) {
        const data = {};
        const reader: FileReader = new FileReader();

        reader.onload = (e: any) => {
            /* read workbook */
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', raw: false, cellDates: false, dateNF: 'mm/dd/yyyy;@' });

            sheetNames.forEach(item => {
                if (wb.SheetNames.findIndex(name => name == item) != -1) {
                    const ws: XLSX.WorkSheet = wb.Sheets[item];
                    data[item] = XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: false });
                }
            });

            this.onExcelDataLoaded.emit(data);
        };

        reader.readAsBinaryString(file);
    }

    public  exportAsXLSX(obj: ExportExcelModel) {
        try {
            let exported: any[] = [];
            let datePipe = new DatePipe('en-US');
            let ExportData = [];
            let data: any[] = []
            if (obj.filter) {
                obj.filter.PageCriteria.PageNumber = 0;
                obj.filter.PageCriteria.PageSize = obj.totalCount;
                obj.filter.applyPaging = false;

                obj.getFromApi(obj.filter).subscribe(res => {
                    //in case if no internet or any issue happened during export process
                    if (res.ErrorDescription) {
                       this._errorHandler.Notify(this._localizer.transform("export_Error"));
                    }
                    //in case the data get 
                    else {
                        ExportData = res.Value.Collection;
                        data = ExportData.map(d => {
                            var test = {}
                            obj.columns.map(c => {
                                if (c.options) {
                                    var arr = c.options.split(',');
                                    if (c.options.includes("replaceIfNaNOrNullOrUndefined")) {//example replaceIfNaNOrNullOrUndefined,0
                                        var index = arr.indexOf("replaceIfNaNOrNullOrUndefined");
                                        d[c.key] = (d[c.key] == 'NaN' || !d[c.key]) ? arr[index + 1] : d[c.key];
                                        test[c.key] = d[c.key];
                                    }
                                    if (c.options.includes("dateFormat")) {  //example "dateFormat,yyyy-MM-dd HH:mm:ss"
                                        var index = arr.indexOf("dateFormat");
                                        test[c.key] = datePipe.transform(d[c.key], arr[index+1])
                                    }
                                    else if (c.options.includes("durationFormat")) {
                                        test[c.key] = this._DurationFormatPipe.transform(d[c.key])
                                    }
                                    else if (c.options.includes("decimalFormat")) {       //example "decimalFormat,1.1-2,KM/HR"
                                        var index = arr.indexOf("decimalFormat");
                                        test[c.key] = this.decimalPipe.transform(d[c.key], arr[index+1]) + (arr[index+2])
                                    }
                                }
                                else {
                                    test[c.key] = d[c.key];
                                }
                            })
                            return test;
                        })
                        exported.push(data);
                        this.exportAsExcelFileWithGrouping(exported, obj.excelName, obj.columns);
                    }
                }, error => {
                   this._errorHandler.Notify(this._localizer.transform("export_Error"));
                });
            }
            //in case  user hit export button without selecting  filter or clicking view report
            else {
                data = []
                exported.push(data);
                this.exportAsExcelFileWithGrouping(exported, obj.excelName, obj.columns);

            }
        }
        catch (e) {
           this._errorHandler.Notify(this._localizer.transform("export_Error"));
        }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/excel.service.ts